import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Segment, Dimmer, Loader, Table } from 'semantic-ui-react';
import { useNavigate } from 'react-router-dom';
import { SG_GET_ADMIN_PHASE_TRANSITIONS } from 'constants/actions';
import PageIntro from '../components/PageIntro';

const PhaseTransitionList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const { phaseTransitions } = useSelector((state) => ({
    phaseTransitions: state.action_phase_transition?.phaseTransitions || [],
  }));

  useEffect(() => {
    setLoading(true);
    dispatch({ type: SG_GET_ADMIN_PHASE_TRANSITIONS });
  }, [dispatch]);

  useEffect(() => {
    setLoading(false);
  }, [phaseTransitions]);

  return (
    <div>
      <PageIntro
        title="Phase Transitions"
        description="Phase transitions define rules to automatically or manually advance campaigns through setup, reports, planning and monitoring phases."
        bullets={[
          'Where data comes from: configured by admins to automate campaign phase progression.',
          'What to expect: transition conditions and scheduling options.',
          'Next steps: create or edit rules to auto-advance campaigns where appropriate.'
        ]}
      />
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h2>Phase Transitions</h2>
        <Button primary onClick={() => navigate('new')}>New</Button>
      </div>

      {loading ? (
        <Segment>
          <Dimmer active>
            <Loader>Loading phase transitions...</Loader>
          </Dimmer>
        </Segment>
      ) : (
        <Table celled striped>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>ID</Table.HeaderCell>
              <Table.HeaderCell>Name</Table.HeaderCell>
              <Table.HeaderCell>From Phase</Table.HeaderCell>
              <Table.HeaderCell>To Phase</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {phaseTransitions && phaseTransitions.results ? (
              phaseTransitions.results.map((pt) => (
                <Table.Row key={pt.id}>
                  <Table.Cell>{pt.id}</Table.Cell>
                  <Table.Cell>{pt.name || pt.id}</Table.Cell>
                  <Table.Cell>{pt.from_phase || '-'}</Table.Cell>
                  <Table.Cell>{pt.to_phase || '-'}</Table.Cell>
                </Table.Row>
              ))
            ) : (
              phaseTransitions.map((pt) => (
                <Table.Row key={pt.id}>
                  <Table.Cell>{pt.id}</Table.Cell>
                  <Table.Cell>{pt.name || pt.id}</Table.Cell>
                  <Table.Cell>{pt.from_phase || '-'}</Table.Cell>
                  <Table.Cell>{pt.to_phase || '-'}</Table.Cell>
                </Table.Row>
              ))
            )}
          </Table.Body>
        </Table>
      )}
    </div>
  );
};

export default PhaseTransitionList;
